import { render, staticRenderFns } from "./PopUpComponent.vue?vue&type=template&id=7fccd54c&scoped=true&"
import script from "./PopUpComponent.vue?vue&type=script&lang=ts&"
export * from "./PopUpComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpComponent.vue?vue&type=style&index=0&id=7fccd54c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fccd54c",
  null
  
)

export default component.exports